import Chart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

interface ServiceChartWithImageProps {
  imageSrc: string;
  percentage: number;
  color: string;
}

export default function ServiceChartWithImage({ imageSrc, percentage, color }: ServiceChartWithImageProps) {
  const series = [percentage];

  const options: ApexOptions = {
    chart: {
      type: 'radialBar',
      height: 100,
    },
    colors: [color], // dynamic color
    plotOptions: {
      radialBar: {
        dataLabels: {
          show: false,
          total: {
            show: false,
          },
        },
        hollow: {
          size: '70%',
        },
        track: {
          show: true,
          strokeWidth: '100%',
          opacity: 0.1,
          margin: 1,
        },
      },
    },
    fill: {
      type: 'solid',
    },
    labels: ['Total'],
    stroke: {
      lineCap: 'round',
    },
  };

  return (
    <div className="relative w-[200px] h-[100px]">
      <Chart options={options} series={series} type="radialBar" height={100} />

      {/* Image centered in chart */}
      <div className="absolute inset-0 flex items-center justify-center">
        <img src={imageSrc} alt="Service Icon" className="w-12 h-12 object-contain" />
      </div>
    </div>
  );
}
